import { categories } from "@/mocks/campus";
import SectionHead from "./SectionHead";
import Reveal from "./Reveal";

interface CategoriesProps {
  onChoose: (slug: string) => void;
}

export default function Categories({ onChoose }: CategoriesProps) {
  return (
    <section id="topics" className="bg-background-100/70 scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <Reveal>
          <SectionHead
            eyebrow="话题分类"
            title="按兴趣开吃，直击你想看的话题"
            desc="从社团趣事到期末冲刺，从食堂风波到毕业季，八类校园吃瓜话题任你挑选。点选即可在热榜中快速过滤。"
          />
        </Reveal>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((c, i) => (
            <Reveal key={c.slug} delay={(i % 4) * 70}>
              <button
                type="button"
                onClick={() => onChoose(c.slug)}
                className="group flex h-full w-full flex-col items-start gap-3 rounded-2xl bg-background-50 p-5 text-left ring-1 ring-background-200 transition-all hover:-translate-y-1 hover:ring-primary-200 cursor-pointer md:p-6"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${c.icon} text-xl`} />
                </span>
                <span className="flex flex-col gap-1.5">
                  <span className="flex items-center gap-2">
                    <span className="font-heading text-lg text-foreground-950">{c.name}</span>
                    <span className="text-[11px] text-foreground-400">{c.count} 条</span>
                  </span>
                  <span className="text-xs leading-relaxed text-foreground-600">{c.desc}</span>
                </span>
                <span className="mt-auto inline-flex items-center gap-1 text-xs font-semibold text-primary-600">
                  查看热门
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}